export const molten = {
  id: "molten",
  name: "Molten",

  scene: {
    backgroundImage: null,
    baseColor: "#07080A",
    radialGlow: "radial-gradient(circle at 50% 42%, rgba(255,120,40,0.22) 0%, rgba(255,120,40,0.12) 40%, transparent 72%)",
    overlayTint: "rgba(8, 8, 10, 0.46)",
    vignette: 0.72,
    parallaxStrength: 0.4,
    particleType: "embers",
  },

  glass: {
    bg: "rgba(18,22,28,0.72)",
    blur: 22,
    border: "rgba(255,255,255,0.1)",
    radius: 22,
  },

  glow: {
    edgeColor: "rgba(255,120,40,0.35)",
    edgeStrength: 0.56,
    heroBoost: 1.4,
  },

  accent: {
    primary: "#FF9A4D",
    secondary: "#E66A2C",
  },

  numeric: {
    positive: "#22c55e",
    warning: "#f59e0b",
    danger: "#ef4444",
  },

  ai: {
    orbStyle: "t",
    orbGlow: "rgba(255,110,40,0.45)",
  },

  tokens: {
    "--tl-bg-0": "#0B0D10",
    "--tl-bg-1": "#07080A",
    "--tl-bg-2": "#050506",
    "--tl-text-0": "#F4E3D2",
    "--tl-text-1": "#D5C5B6",
    "--tl-text-muted": "#9B93A1",
    "--tl-accent-0": "#FF9A4D",
    "--tl-accent-1": "#E66A2C",
    "--tl-glass-bg": "rgba(18,22,28,0.72)",
    "--tl-glass-border": "rgba(255,255,255,0.1)",
    "--tl-glass-blur": "22px",
    "--tl-glass-shadow": "0 16px 44px rgba(0,0,0,0.56)",
    "--tl-glass-glow-color": "rgba(255,120,40,0.35)",
    "--tl-glow-edge-color": "rgba(255,120,40,0.35)",
    "--tl-glow-edge-strength": "0.56",
    "--tl-glow-hero-boost": "1.4",
    "--tl-radius": "22px",
    "--tl-molten-wordmark-gradient": "linear-gradient(180deg, #FFD6A0 0%, #FF9A4D 35%, #E66A2C 70%, #B6481C 100%)",
  },
};
